export function notUndefined<T>(val: T | undefined): val is T {
    return typeof val !== 'undefined';
}

export function dropUndefined<T>(values: (T | undefined)[]): T[] {
    return values.filter(notUndefined);
}

type Maybe<T> = T | undefined;

export function maybeGet<T, U extends keyof T>(obj: Maybe<T>, key: Maybe<U>): Maybe<T[U]> {
    if (typeof obj === 'undefined') {
        return;
    }

    if (typeof key === 'undefined') {
        return;
    }

    return obj[key];
}
